import { enableProdMode, importProvidersFrom } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { register } from 'swiper/element/bundle';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import * as fabricImport from 'fabric';
const normalizedFabric: any =
 (fabricImport as any).default?.fabric ||
 (fabricImport as any).default ||
 fabricImport;
(window as any).fabric = normalizedFabric;
if (environment.production) {
  enableProdMode();
}
register();
bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppModule)
  ]
}).catch(err => console.error(err));
